<!-- 
TELA PARA ADICIONAR ADICIONAR NOVOS CONTATOS AO PARTICIPANTE ATRAVES DO PEDIDO DE VENDA
-->

<template>
    <div id="mymodal" class="nb-modal-scrollable">
        <div class="container nb-modal-scrollable-container" style="width: 600px; max-width: 100%">
            <div class="nb-modal-header">
                <bar-manut 
                    single-entity="Contato" 
                    :crud="this.crud" 
                    @closeform="closeForm" 
                    @save="handleSave">
                </bar-manut>
            </div>
            <div class="nb-modal-scrollable-body">
                <div class="row">
                    <form-field v-model="partcontato.nomecontato" type="text" col="12" :metadata="metadata.partcontato.nomecontato" 
                        name="nomecontato" :v-errors="errors" v-validate="metadata.partcontato.nomecontato.validator"></form-field>
                    <form-field v-model="partcontato.email" type="email" col="12" :metadata="metadata.partcontato.email" 
                        name="email" :v-errors="errors" v-validate="metadata.partcontato.email.validator"></form-field>
                    <form-field v-model="partcontato.fone1" type="fone" col="12" :metadata="metadata.partcontato.fone1" 
                        name="fone1" :v-errors="errors" v-validate="metadata.partcontato.fone1.validator"></form-field>
                    <form-field v-model="partcontato.fone2" type="fone" col="12" :metadata="metadata.partcontato.fone2" 
                        name="fone2" :v-errors="errors" v-validate="metadata.partcontato.fone2.validator"></form-field>
                    <form-field v-model="partcontato.fone3" type="fone" col="12" :metadata="metadata.partcontato.fone3" 
                        name="fone3" :v-errors="errors" v-validate="metadata.partcontato.fone3.validator"></form-field>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import { SysVars } from '../main'
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'

export default {
    props: {
        codpart: '',
        crud: '',
    },

    data() {
        return {
            crudText: '',
            partcontato: {...this.$store.getters.getEntities.partcontato},
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
        }
    },

    computed: {
        editing: function () {
            return this.crud == SysVars.crudU
        }

    },

    methods: {
        closeForm () {
            this.$emit('closeform')
        },

        handleSave () {
            //BOTAO SALVAR
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.apiPost()
                }
            })
        },

        handleDelete () {
            //BOTAO Excluir
            this.apiDelete()
        },

        async loadData () {
            //carrega o registro para alteracao ou visualizacao
            // await this.$store.dispatch('loadPartcontato', { codpart: this.codpart, id: this.seqcontato} )
            // if (this.$store.getters.getEstado) {
            //     this.partcontato = {...this.$store.getters.getPartcontato}
            // }  
            // this.$nextTick(function () {
            //     jQuery('[data-toggle="tooltip"]').tooltip()
            // })
        },

        async apiPost () {
            //efetua a gravacao

            var modulo = 'cg/partcontato/'

            this.partcontato.codpart = this.codpart
            var sendData = {}

            sendData = { partcontato: this.partcontato }

            let metodo = 'post'
            let update = false
            if (this.crud != SysVars.crudI) {
                metodo = 'put'
                update = true
            }

            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                if (update) {
                    this.$erpToastUpdated()
                } else {
                    this.$erpToastInserted()
                }
                this.errmessages = {}
                this.$emit('closeform', data)
            }
        },
        
    },

    components: {

    },

    beforeCreate () {

    },

    created () {
        this.$nextTick(function () {
          jQuery('[data-toggle="tooltip"]').tooltip()
        })

        this.crudText = this.$crudText(this.crud)

        if (this.crud == SysVars.crudI) {
        } else {
            this.loadData()  
        }
    }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/customer-contato-form.vue